module.exports = __webpack_public_path__ + "img/imagen1.ab84a7c8.png";